import React, { useState, useEffect, useCallback } from "react";
import CustomDateRangeV3 from "../../helper/Table/CustomDateRangeV3";
import { Table, PageHeader, Card, Form, Select, Row, Col, Input, Button } from "antd";
import { SearchOutlined, CheckCircleOutlined, FieldTimeOutlined, CloseCircleOutlined } from "@ant-design/icons";
import ExportModalV3 from "../../helper/ExportModalV3";
import moment from "moment";
import { API_DATA_SOURCE, THREEDS_URL } from "../../config/config";
import axios from "axios";
import Cookies from "js-cookie";
import GroupAccess from "./../../helper/GroupAccess";
import { Resizable } from "react-resizable";
import DataFetchHookThreeDS from "../../helper/DataFetchHookThreeDS";

// import { DatePicker } from "antd";
import createExportDateHandler from "../../helper/createExportDateHandler";
import CustomPaginationV2 from "../../helper/Table/CustomPaginationV2";
// const { RangePicker } = DatePicker;

const { Option } = Select;

const MAX_DATERANGE = 3;
const DEFAULT_DATERANGE = 7;
// const MAX_DATERANGE = 0;
// const MAX_RANGETYPE = "months";
const DEFAULT_RANGETYPE = "days";
// const TODAY = moment();
const START_DATE = moment().subtract(DEFAULT_DATERANGE, DEFAULT_RANGETYPE);
const END_DATE = moment();

const ResizableTitle = (props) => {
    const { onResize, width, ...restProps } = props;

    if (!width) {
        return <th {...restProps} />;
    }

    return (
        <Resizable
            width={width}
            height={0}
            handle={
                <span
                    className="react-resizable-handle"
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                />
            }
            onResize={onResize}
            draggableOpts={{
                enableUserSelectHack: false,
            }}
        >
            <th {...restProps} />
        </Resizable>
    );
};

const ThreeDSecureList = (props) => {
    const DATA_URL_THREEDS = THREEDS_URL + '/api/v1/3ds/transaction';
    const DATA_URL_EXPORT = THREEDS_URL + '/api/v1/3ds/reports'    
    const [{ data, totalResult, isLoading, requestData }, , setRequestData] = DataFetchHookThreeDS(
        DATA_URL_THREEDS,
        "POST",
        {
            startDate: START_DATE,
            endDate: END_DATE,
            page: 1,
            size: 20,
            order: "DESC",
        },
    );
    const [formData, setFormData] = useState();
    const [dates, setDates] = useState([START_DATE, END_DATE]);
    // const [dateValue, setDateValue] = useState(TODAY); // eslint-disable-line
    const [currentPage, setCurrentPage] = useState(1);
    const [merchantList, setMerchantList] = useState([]);
    const [currencyList, setCurrencyList] = useState(null);


    const { t } = props;
    // const dateFormat = "YYYY/MM/DD";
    const initFormData = {
        dateRange: [START_DATE, END_DATE],
        // dateValue: dateValue,
        field: null,
        keyword: null,
        status: [],
        currency: [],
        order: null,
        merchant: [],
    };
    const [form] = Form.useForm();

    useEffect(() => {
        formValInit();
        if (merchantList.length === 0) {
            getMerchantList();
        }
        if(!currencyList) {
            getCurrencyList();
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const getMerchantList = useCallback(() => {
        let apiUrl = THREEDS_URL + "/api/v1/merchants";
        let token  = Cookies.get("threeds_token");
        axios
            .post(
                apiUrl,
                {getall:true},
                { headers: { Authorization: "Bearer " + token, Authuser: Cookies.get("authuser") } }
            )
            .then(async ({ data }) => {
                await setMerchantList(data.list);
            })
            .catch(() => false);
    }, []);

    const getCurrencyList = useCallback(() => {
        axios
        .post(API_DATA_SOURCE + `/currency`, {}, { headers: { Authorization: "Bearer " + Cookies.get("access_token") } })
        .then(({ data }) => {
            setCurrencyList(data);
        })
        .catch((error) => console.log(error));
    }, []);

    const handleChange = (pagination, filters, sorter, { currentDataSource }) => {
        var orderBy = 'DESC';
        if (sorter.order === 'ascend') {
            orderBy = 'ASC';
        }
        var sortField = 'timestamp';
        if (sorter.field !== undefined) {
            sortField = sorter.field;
        }
        var p = pagination.current;
        if (Object.keys(sorter).length > 0 && requestData.sort_field !== sortField) {
            p = 1;
            setCurrentPage(1);
        }
        setRequestData({ ...requestData, order: orderBy, sort_field: sortField, page: p, size: pagination.pageSize });
    };

    const exportHeaders = [
        { label: "Transaction Date", key: "timestamp" },
        { label: "TXID", key: "txid" },
        { label: "Trans. Status", key: "trans_status" },
        { label: "Merchant Name", key: "site_name" },
        { label: "Account Name", key: "account_name" },
        { label: "Card No.", key: "card_no" },
        { label: "Amount", key: "amount" },
        { label: "Action", key: "tx_action" },
        { label: "Status", key: "response" },
    ];

    const exportHeadersOptional = [];

    const [columns, setColumns] = useState([
        {
            dataIndex: "timestamp",
            key: "timestamp",
            title: t("tables.fields.transaction_date"),
            render: (timestamp) => moment(timestamp).format("YYYY-MM-DD HH:mm:ss"),
            width: 150,
            sorter: {
                compare: (a, b) => moment(a.timestamp).diff(moment(b.timestamp)),
            },
        },
        {
            dataIndex: "txid",
            key: "txid",
            title: t("tables.fields.txid"),
            width: 150,
            sorter: {
                compare: (a, b) => a.txid - b.txid,
            },
            render: (id, record) => {
                let url = `/3dsecure/${id}?tx_action=${record.tx_action}`;
                return <a href={url} target="_blank" rel="noopener noreferrer">
                    {record.txid}
                </a>
            },
        },
        {
            dataIndex: "transStatus",
            key: "transStatus",
            title: t("tables.fields.transStatus"),
            width: 100,
            sorter: {
                compare: (a, b) => a.sitename.localeCompare(b.sitename),
            },
        },
        {
            dataIndex: "sitename",
            key: "sitename",
            title: t("tables.fields.merchantname"),
            width: 150,
            sorter: {
                compare: (a, b) => a.sitename.localeCompare(b.sitename),
            },
        },
        {
            dataIndex: "account_name",
            key: "account_name",
            title: t("tables.fields.card_name"),
            width: 150,
            sorter: {
                compare: (a, b) => String(a.account_name ?? '').localeCompare(String(b.account_name ?? '')),
            },
        },
        {
            dataIndex: "card_no",
            key: "card_no",
            title: t("tables.fields.card_no"),
            width: 150,
            sorter: {
                compare: (a, b) => String(a.card_no ?? '').localeCompare(String(b.card_no ?? '')),
            },
        },
        {
            dataIndex: "amount",
            key: "amount",
            title: t("tables.fields.amount"),
            width: 150,
            sorter: {
                compare: (a, b) => String(a.amount?? '').localeCompare(String(b.amount ?? '')),
            },
        },
        {
            dataIndex: "tx_action",
            key: "tx_action",
            title: t("tables.fields.action"),
            width: 150,
            sorter: {
                compare: (a, b) => a.tx_action.localeCompare(b.tx_action),
            },
        },
        {
            dataIndex: "response",
            key: "response",
            title: t("tables.fields.status"),
            width: 150,
            sorter: {
                compare: (a, b) => a.response.localeCompare(b.response),
            },
            render: (response, record) => getStatus(response),
        },
    ]);

    const formValInit = () => {
        setFormData(initFormData);
        form.setFieldsValue(initFormData);
    };

    const clearAll = () => {
        setCurrentPage(1);
        setFormData(initFormData);
        setRequestData({ ...requestData, ...initFormData, startDate: null, endDate: null, page: 1 });
        form.setFieldsValue(initFormData);
    };

    const formValChange = (chgV, allV) => {
        setFormData(allV);
    };

    const onFinish = () => {
        let startDate = null;
        let endDate = null;
        let searchData = {};
        if (formData) {
            if (dates) {
                startDate = dates[0] ? dates[0] : null;
                endDate = dates[1] ? dates[1] : null;
            }
            if (formData.dateValue) {
                startDate = formData.dateValue ? formData.dateValue : null;
                endDate = formData.dateValue ? formData.dateValue : null;
            }
            searchData = {
                keyword: formData.keyword ? formData.keyword.trim() : null,
                field: formData.field,
                status: formData.status,
                currency: formData.currency,
                order: formData.order,
                mid: formData.merchant,
            };
        }

        setCurrentPage(1);
        setRequestData({ ...requestData, ...searchData, startDate: startDate, endDate: endDate, page: 1 });
    };

    const getStatus = (status) => {
        if (!status) return "";
        let statusText = status.charAt(0) + status.toLowerCase().slice(1);
        switch (status) {
            case "APPROVED":
                return (
                    <div className="d-flex align-items-center">
                        <CheckCircleOutlined style={{ color: "#52c41a", fontSize: "18px", marginRight: "4px" }} />
                        <span>{statusText}</span>
                    </div>
                );
            case "PENDING":
                return (
                    <div className="d-flex align-items-center">
                        <FieldTimeOutlined style={{ color: "#1890ff", fontSize: "18px", marginRight: "4px" }} />
                        <span>{statusText}</span>
                    </div>
                );
            case "DECLINED":
            case "PAYG_ERROR":
                return (
                    <div className="d-flex align-items-center">
                        <CloseCircleOutlined style={{ color: "#f5222d", fontSize: "18px", marginRight: "4px" }} />
                        <span>{statusText}</span>
                    </div>
                );
            default:
                return "";
        }
    };

    /**
     * callback to reflect the changes on dates to the passing request data
     * 
     * @param array values 
     */
    const handleDateChange = createExportDateHandler(requestData);


    const AdvancedSearchForm = () => (
        <div className="search-wrap">
            <Card title={t("tables.actions.search")} size="small">
                <Form form={form} size="large" name="advanced_search" className="ant-advanced-search-form" onValuesChange={formValChange} onFinish={onFinish}>
                    <Row gutter={[16, 16]}>
                        {/* <Col className="gutter-row" span={5}>
                            <Form.Item name="dateValue">
                                <DatePicker initialValues={moment(TODAY.format(dateFormat), dateFormat)} style={{ width: "100%" }} />
                            </Form.Item>
                        </Col> */}
                        <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} lg={{ span: 8 }} xl={{ span: 6 }}>
                            <Form.Item name="dateRange">
                                <CustomDateRangeV3 t={t} state={{ dates, setDates }} unit="months" limit={MAX_DATERANGE} onChange={handleDateChange} />
                            </Form.Item>
                        </Col>
                        <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} lg={{ span: 8 }} xl={{ span: 4 }}>
                            <Form.Item name="field">
                                <Select 
                                        showSearch
                                        showArrow="true"
                                        style={{ width: "100%" }} 
                                        placeholder={t("tables.fields.field")}>
                                    <Option value="txid">{t("tables.fields.txid")}</Option>
                                    <Option value="card_no">{t("tables.fields.card_number")}</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} lg={{ span: 8 }} xl={{ span: GroupAccess("SYSADMIN") ? 7 : 9 }}>
                            <Form.Item name="keyword">
                                <Input placeholder={t("tables.fields.keyword")} />
                            </Form.Item>
                        </Col>
                        {GroupAccess("SYSADMIN") ? (
                            <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} lg={{ span: 8 }} xl={{ span: 7 }}>
                                <Form.Item name="merchant">
                                    <Select
                                        showSearch
                                        mode="multiple"
                                        showArrow="true"
                                        maxTagCount="responsive"
                                        style={{ width: "100%" }}
                                        optionFilterProp="children"
                                        filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                                        filterSort={(optionA, optionB) => optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())}
                                        placeholder={t("contents.merchants.title")}
                                    >
                                        {merchantList
                                            ? merchantList.map((item) => (
                                                  <Option key={item.mid} value={item.mid}>
                                                      { item.site_name + ` (mid: ` + item.mid + `)`}
                                                  </Option>
                                              ))
                                            : null}
                                    </Select>
                                </Form.Item>
                            </Col>
                        ) : (
                            ""
                        )}
                        {/* <Col className="gutter-row" span={5}>

                            <Form.Item name="order">
                                <Select style={{ width: "100%" }} placeholder="Order">
                                    <Option value="ASC">ASC</Option>
                                    <Option value="DESC">DESC</Option>
                                </Select>
                        </Form.Item>
                        </Col>*/}
                        <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} lg={{ span: 8 }} xl={{ span: 6 }}>
                            <Form.Item name="currency">
                                <Select 
                                    showArrow="true"
                                    mode="multiple" 
                                    allowClear
                                    maxTagCount="responsive" 
                                    style={{ width: "100%" }} 
                                    placeholder={t("tables.fields.currency")}>
                                    {currencyList
                                        ?
                                        Object.keys(currencyList).map((item, index) => (
                                            <Option key={index} value={currencyList[index].alpha3}> {currencyList[index].alpha3} </Option>
                                        ))
                                        : null
                                    }
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} lg={{ span: 8 }} xl={{ span: 4 }}>
                            <Form.Item name="status">
                                <Select 
                                    showArrow="true"
                                    mode="multiple" 
                                    maxTagCount="responsive" 
                                    allowClear 
                                    style={{ width: "100%" }} 
                                    placeholder={t("tables.fields.status")}>
                                    <Option value="APPROVED">APPROVED</Option>
                                    <Option value="DECLINED">DECLINED</Option>
                                    <Option value="PAYG_ERROR">PAYG_ERROR</Option>
                                    <Option value="PENDING">PENDING</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col
                            className="gutter-row"
                            xs={{ span: 24 }}
                            sm={{ span: 12 }}
                            md={{ span: 6, offset: 12 }}
                            lg={{ span: 4, offset: 16 }}
                            xl={{ span: 3, offset: GroupAccess("SYSADMIN") ? 7 : 2 }}
                        >
                            <Form.Item>
                                <Button type="secondary" onClick={() => clearAll()} block>
                                    {t("tables.actions.clear_all")}
                                </Button>
                            </Form.Item>
                        </Col>
                        <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }} xl={{ span: 4 }}>
                            <Form.Item>
                                <Button type="primary" htmlType="submit" block>
                                    <SearchOutlined /> {t("tables.actions.search")}
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </div>
    );

    const getHeaderTable = () => (
        <div className="custom-table--header d-flex justify-content-between align-items-center">
            <h3 className="table-title">{t("contents.3dsecure.title")}</h3>
            <ExportModalV3
                t={t}
                keyname="export_all"
                title={t("tables.actions.export")}
                data={requestData}
                data_url={DATA_URL_EXPORT}
                headers={exportHeaders}
                fieldHeadersOptional={exportHeadersOptional}
                filename={`3ds_${moment().format("YYMMDD_HHmmss_SSSS")}.csv`}
                style={{ marginLeft: 8 }}
                customToken={ Cookies.get("threeds_token") }
            />
        </div>
    );

    const getDataSource = (datalist) => (datalist && Array.isArray(datalist) ? datalist : []);

    const handleResize =
        (index) =>
        (_, { size }) => {
            const newColumns = [...columns];
            newColumns[index] = { ...newColumns[index], width: size.width };
            setColumns(newColumns);
        };

    const mergeColumns = columns.map((col, index) => ({
        ...col,
        onHeaderCell: (column) => ({
            width: column.width,
            onResize: handleResize(index),
        }),
    }));

    return (
        <div>
            <PageHeader title={t("contents.3dsecure.title")}></PageHeader>
            {AdvancedSearchForm()}
            <Table
                loading={isLoading}
                title={() => getHeaderTable()}
                components={{
                    header: {
                        cell: ResizableTitle,
                    },
                }}
                rowKey="txid"
                size="small"
                columns={mergeColumns}
                className="tableOverflow table-v3 custom-pagination custom-pagination-v3"
                dataSource={getDataSource(data.datalist)}
                onChange={handleChange}
                sortDirections={["ascend", "descend", "ascend"]}
                pagination={CustomPaginationV2({ totalResult, currentPage, requestData, setRequestData, setCurrentPage })}
            />
        </div>
    );
};

export default ThreeDSecureList;
